import React from 'react'

const Star = () => {
    return (

        <svg className='star-icon' id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200.4 190.93">

            <path d="M103.41,2.33l21.34,65.68c.45,1.39,1.75,2.33,3.21,2.33h69.06c3.27,0,4.63,4.19,1.98,6.11l-55.87,40.59c-1.18.86-1.68,2.38-1.23,3.78l21.34,65.68c1.01,3.11-2.55,5.7-5.2,3.78l-55.87-40.59c-1.18-.86-2.79-.86-3.97,0l-55.87,40.59c-2.65,1.92-6.21-.66-5.2-3.78l21.34-65.68c.45-1.39-.04-2.92-1.23-3.78L1.4,76.45c-2.65-1.92-1.29-6.11,1.98-6.11h69.06c1.46,0,2.76-.94,3.21-2.33L96.99,2.33c1.01-3.11,5.41-3.11,6.42,0Z" />
        </svg>
    )
}

export default Star
